import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  host: { 'test-id': 'operation-info' },
  selector: 'operation-info',
  styleUrls: ['./operation-info.component.scss'],
  templateUrl: './operation-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperationInfoComponent {
  @Input() id: string;
  @Input() title: string;
  @Input() subTitle: string;
  @Input() path: string;
}
